/**
 * URLs for MLB static assets (player headshots, team logos) and MLB.com pages.
 */

const PLAYER_AVATAR_BASE = 'https://midfield.mlbstatic.com/v1/people';
const TEAM_LOGO_BASE = 'https://www.mlbstatic.com/team-logos';
const MLB_GAMEDAY_BASE = 'https://www.mlb.com/gameday';

/**
 * Return the URL for a player's headshot/avatar.
 * @param {number|string} playerId - MLB player ID (e.g. 701655)
 * @returns {string|null} URL for 60px spot image, or null if no id
 */
export function getPlayerAvatarUrl(playerId) {
  if (playerId == null || playerId === '') return null;
  const id = typeof playerId === 'number' ? playerId : parseInt(String(playerId), 10);
  if (Number.isNaN(id)) return null;
  return `${PLAYER_AVATAR_BASE}/${id}/spots/60?zoom=1.2`;
}

/**
 * Return the URL for a team's logo (SVG). Uses team-cap-on-dark variant for dark mode.
 * @param {number|string} teamId - MLB team ID (e.g. 120)
 * @returns {string|null} URL for team logo SVG, or null if no id
 */
export function getTeamLogoUrl(teamId) {
  if (teamId == null || teamId === '') return null;
  const id = typeof teamId === 'number' ? teamId : parseInt(String(teamId), 10);
  if (Number.isNaN(id)) return null;
  return `${TEAM_LOGO_BASE}/team-cap-on-dark/${id}.svg`;
}

/**
 * Return the URL for the official MLB Gameday page for a game.
 * @param {number|string} gameId - MLB game ID (e.g. 831516)
 * @returns {string|null} URL for Gameday page, or null if no id
 */
export function getMlbGamedayUrl(gameId) {
  if (gameId == null || gameId === '') return null;
  const id = typeof gameId === 'number' ? gameId : String(gameId).trim();
  if (id === '' || id === 'undefined') return null;
  return `${MLB_GAMEDAY_BASE}/${id}`;
}
